import script from "./ServiceTeamsReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceTeamsReport.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceTeamsReport.vue?vue&type=style&index=0&id=6e1557c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e1557c8"]])

export default __exports__